<template lang="pug">
.price-and-tax
  BriqInput(
    label="Price" 
    placeholder="Price" 
    name="Price"
    data-test-id="price"
    v-model="product.Price"
    required
    type="number"
    :prepend="currencySymbol($locale, $currency)"
    step="0.01"
    min="0"
    :disabled="disabled"
    :error="priceError"
    @blur="vuelidate.product.Price.$touch()"
    )
  BriqAlert(v-show="showPriceWarning" variant="warning")
    span Warning
    span(style="margin: 0px 8px") | 
    span You are about to change the base price of this product. This change will affect all deal prices this product is connected to.
  BriqCheckbox(
    label="Price includes taxes"
    name="PriceIncludesTax"
    v-model="product.PriceIncludesTax"
    :disabled="disabled"
    data-test-id="price-includes-tax"
    )
  BriqMultiselect(
    label="Tax percentage"
    required="required"
    :options="taxOptions"
    :valueSetter="tax => tax.Key"
    track-by="Key"
    display="Description"
    v-model="product.TaxKey"
    :disabled="disabled"
    :error="taxKeyError"
    @blur="vuelidate.product.TaxKey.$touch()"
    data-test-id="tax-percentage"
    )
  BriqRadio(
    label="Price variant"
    :options="priceTypeOptions"
    :disabledOptions="disablePerTeam"
    v-model="product.PriceType"
    :disabled="disabled"
    required
    data-test-id="price-variant"
    )
</template>

<script>
import { currencySymbol } from '@/helpers/intlFormatter.js'
import { validatePaths } from '@/vue/util/propValidators'

export default {
  name: 'PriceAndTax',
  components: {},
  props: {
    product: { type: Object, required: true },
    selectedResource: Object,
    vuelidate: {
      type: Object,
      required: true,
      validator: validatePaths([
        ['product', 'Price', '$touch'],
        ['product', 'Price', '$error'],
        ['product', 'TaxKey', '$touch'],
        ['product', 'TaxKey', '$error'],
      ]),
    },
    taxOptions: { type: Array, required: true },
    disabled: Boolean,
  },
  data() {
    return {
      priceTypeOptions: {
        PerResource: 'Per Resource',
        PerTeam: 'Per Team',
        PerPerson: 'Per Person',
      },
      originalPrice: null,
    }
  },
  computed: {
    priceError() {
      if (!this.vuelidate.product.Price.$error) return null
      return 'Please enter a price'
    },
    taxKeyError() {
      if (!this.vuelidate.product.TaxKey.$error) return null
      return 'Please choose a tax percentage'
    },
    resourceUsesTeams() {
      return this.selectedResource?.TeamSize > 0
    },
    disablePerTeam() {
      return {
        PerResource: false,
        PerTeam: !this.resourceUsesTeams,
        PerPerson: false,
      }
    },
    changedPrice() {
      return this.originalPrice !== this.product.Price
    },
    showPriceWarning() {
      return this.product.Key && this.changedPrice
    },
  },
  methods: { currencySymbol },
  watch: {
    resourceUsesTeams(newValue, oldValue) {
      // if per team becomes unavailable, reset price and select PerPerson
      if (oldValue && !newValue) {
        this.product.Price = null
        this.product.PriceType = 'PerPerson'
      }
    },
  },
  created() {
    this.originalPrice = this.product.Price
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.briq-alert
  margin-top -16px
  margin-bottom 24px

.briq-form-element
  margin-bottom space-S
</style>
